import * as graphql from 'generated/graphql';
import { IOption } from 'packages/kakapo-ui-services/types/Option';

export interface IUserRecipient {
	userId: string;
	userData: graphql.User;
}

export interface IEmailRecipient {
	name: string;
	email: string;
}

export type Recipient = IUserRecipient | IEmailRecipient;

export function isUserRecipient(toBeDetermined: Recipient): toBeDetermined is IUserRecipient {
	return (toBeDetermined as IUserRecipient).userId != null;
}

export type RecipientUserOption = IOption<graphql.User>;
export type RecipientEmailOption = IOption<void>;
export type RecipientOption = RecipientUserOption | RecipientEmailOption;

export function isUserRecipientOption(
	toBeDetermined: RecipientOption,
): toBeDetermined is RecipientUserOption {
	return (toBeDetermined as RecipientUserOption).data != null;
}
